module.exports = __webpack_public_path__ + "media/images/pic/brodno-contact-choice-9530c47c144f6df9d251d0d1ca1ea7e9.svg";